import _ from 'lodash'
import { Moment } from 'moment'
import { DashboardData } from '../api'
import { Habit, NewHabitType, OldHabitType } from '../components/TargetScores'
import { habitNames, habitTypeMap } from './constants'

export const userNameMap = {
  guy: 'Guy ✍🏻',
  hari: 'Hari 🔥',
  alex: 'Alex 👨🏻‍🎤',
  marybeth: 'MaryBeth 👁',
  martin: 'Martin 🎶',
  nathan: 'Nathan 🌄',
  jon: 'Jon🕺',
  wim: 'Wim 🎸',
  abi: 'Abi💥',
  adarsh: 'Adarsh ⛰',
  dana: 'Dana 🎯',
  tiana: 'Tiana 💯',
  alexr: 'AlexR',
  rob: 'Rob',
}

// @ts-ignore:
export const mapUserName = (userName) => userNameMap[userName]

// @ts-ignore:
export const convertRowsToHabits = ({ rows, date }) =>
  habitNames.map((habitType) => {
    // @ts-ignore:
    const row = rows.find((row) => row.Habit === habitType)
    if (row) {
      return {
        name: habitType,
        target: row.Target,
        score: parseInt(row[date]),
      }
    } else {
      return null
    }
  })

// @ts-ignore:
export const extractGroupDailyScores = ({ rows }) => {
  // @ts-ignore:
  const scores = rows.find(
    (row: any) => row.People === 'Group daily totals'
  )._rawData
  return [...scores.slice(3, 9), ...scores.slice(10)]
}

// @ts-ignore:
export const formatGroupScores = ({ groupScores }) => {
  return (
    groupScores
      .concat(_.fill(Array(12 - groupScores.length), null))
      // @ts-ignore:
      .map((score, index) => ({
        score,
        index: `Day ${index + 1}`,
      }))
  )
}

// @ts-ignore:
export const getTeammatesByPlayerName = ({ teams }) => {
  const teammatesByName = {}
  // @ts-ignore:
  teams.forEach(({ playerNames }) => {
    if (playerNames.length > 1) {
      // @ts-ignore:
      teammatesByName[playerNames[0]] = playerNames[1]
      // @ts-ignore:
      teammatesByName[playerNames[1]] = playerNames[0]
    }
  })

  return teammatesByName
}

export interface DatabaseRecord {
  id: string
}

export interface Target extends DatabaseRecord {
  habitType: NewHabitType
  text: string
  miwStarterTarget?: number
  miwMainTarget?: number
}

export enum MiwProgress {
  none = 'none',
  starter = 'starter',
  main = 'main',
}

export interface Score extends DatabaseRecord {
  day: Moment
  habitType: NewHabitType
  points: number
  miwProgress?: MiwProgress
  playerId: string
  isCurrentRound?: boolean
}

export function makeHabitsFromTargetsAndScores(
  targets: Target[],
  scores: Score[]
): Habit[] {
  return targets.map((t) => {
    const score = scores.find((s) => s.habitType === t.habitType)
    return {
      name: _.findKey(habitTypeMap, (v) => v === t.habitType) as OldHabitType,
      target: t.text,
      score: (score?.points) || 0,
      miwProgress: score?.miwProgress,
      miwStarterTarget: t.miwStarterTarget,
      miwMainTarget: t.miwMainTarget,
      scoreId: score?.id,
      scoreDay: score?.day,
    }
  })
}

export function filterDashboardDataToDay({
  dashboardData,
  day,
}: {
  dashboardData: DashboardData
  day: Moment
}): DashboardData {
  const isFromSelectedDay = (t: { day: Moment }) => t.day.isSame(day, 'day')

  return {
    ...dashboardData,
    scores: dashboardData.scores.filter(isFromSelectedDay),
    notes: dashboardData.notes.filter(isFromSelectedDay),
    teammateScores: dashboardData.teammateScores.filter(isFromSelectedDay),
  }
}
